// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"2d2defcd","683":"642516c1"}[chunkId] + ".chunk.js";
};